import { api } from '../../services/api'

export const showSuccess = (message) => {
	return (dispatch) => {
		dispatch({ type: 'SHOW_ALERT', payload: { severity: 'success', message } })
	}
}

export const showError = (error) => {
	return (dispatch) => {
		let errorStr = ''
		if (typeof error === 'string') errorStr = error
		else if (error?.message) errorStr = error.message
		else errorStr = 'Error'

		dispatch({ type: 'SHOW_ALERT', payload: { severity: 'error', message: errorStr } })
	}
}

export const createItem = (item) => {
	return (dispatch) => {
		dispatch({ type: 'ADD_CHARGE' })

		return api
			.post('/line-items/add', item)
			.then((response) => {
				if (item.type === 'visit_promo') {
					dispatch(showSuccess('Promo added!'))
					dispatch({ type: 'ADD_VISIT_ITEM_SUCCESS', payload: response.data })
				} else {
					dispatch({ type: 'ADD_CHARGE_SUCCESS', payload: response.data })
				}
			})
			.catch((e) => {
				if (e && e.data && typeof e.data === 'string' && item.type === 'gift_card') {
					dispatch(showError(e.data))
				}
				dispatch({ type: 'ADD_CHARGE_FAIL' })
			})
	}
}

export const addAddOnFunds = (item) => {
	return (dispatch) => {
		dispatch({ type: 'ADD_BANK' })

		return api
			.post(`/addOnBank/${item.household_id}`, item)
			.then((response) => {
				dispatch(showSuccess('Addon Bank Updated'))
				dispatch({ type: 'ADD_BANK_SUCCESS', payload: response.data.addon_bank })
			})
			.catch(() => {
				dispatch(showError('Error adjusting addon bank'))
				dispatch({ type: 'ADD_BANK_FAIL' })
			})
	}
}
